export const moduleConstant = {
  apiConstant: `/api/prodDept/reworkRecordRoute`,
  heading: 'REWORK RECORD',
};
